module.exports = __webpack_public_path__ + "media/1.ce192ba2.mp3";